import React from "react";
import PropTypes from "prop-types";

/**
 * Handles showing the contents of the wrapper only once (tracked by browser local storage).
 */
export default function(Component) {
  class ShowOnceWrapper extends React.Component {
    constructor(props) {
      super(props);

      this.key = props.remember ? `show_once_${props.remember}` : null;

      this.state = {
        shown: this.determineShownState(props),
        hidden: false,
      };
    }

    componentDidMount() {
      this.UNSAFE_componentWillReceiveProps(this.props);
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillReceiveProps(props) {
      if (!props.show) {
        return;
      }

      const shown = this.determineShownState(props);
      const { show: currentShow } = this.props;

      if (shown && this.key) {
        localStorage.setItem(this.key, true);
      }

      this.setState({
        shown,
        hidden: currentShow !== props.show && !shown,
      });
    }

    shouldComponentUpdate(nextProps) {
      const { show } = this.props;
      // possible risk because other props that are passed down will be ignored?
      return nextProps.show !== show;
    }

    determineShownState(props) {
      return !this.key || (localStorage.getItem(this.key) == null && props.show);
    }

    render() {
      const { shown, hidden } = this.state;

      return (
        <Component
          {...this.props}
          shown={shown}
          hidden={hidden}
          ref={c => {
            this.child = c;
          }}
        />
      );
    }
  }

  ShowOnceWrapper.propTypes = {
    // when true, this contents of this wrapper will be displayed
    show: PropTypes.bool,

    // a unique key to use to keep track of whether the user has seen this before
    remember: PropTypes.string,
  };

  return ShowOnceWrapper;
}
